import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import useGrantedRewardExpirationNag from 'hooks/useGrantedRewardExpirationNag'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('components.granted_reward_expiration_banner')

const GrantedRewardExpirationBanner = () => {
  const [css] = useStyletron()
  const { showBanner, dismiss, handleConfigure } =
    useGrantedRewardExpirationNag()

  if (!showBanner) {
    return null
  }

  return (
    <div
      role="status"
      aria-label={t('banner_aria_label')}
      data-testid="granted-reward-banner"
      // `below-navbar` provides the navbar clearance for the in-flow banner.
      // It must live in the DOM only when the banner actually renders — an empty
      // wrapper would trigger `.below-navbar ~ main { padding-top: 0 }` and strip
      // every page's clearance (clips the fixed campaign builder subnav).
      className={
        'below-navbar ' +
        css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          backgroundColor: palette.eggYolk10,
          boxSizing: 'border-box',
          width: '100%',
        })
      }
    >
      <span
        className={css({
          color: palette.grey70,
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '0.25px',
          fontWeight: 400,
          flex: '1 0 0',
        })}
      >
        {t('message_prefix')}{' '}
        <button
          type="button"
          onClick={handleConfigure}
          className={css({
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            color: palette.belizeHole,
            textDecoration: 'underline',
            fontWeight: 600,
            font: 'inherit',
            ':focus-visible': {
              outline: `2px solid ${palette.belizeHole}`,
              outlineOffset: '2px',
              borderRadius: '2px',
            },
          })}
        >
          {t('message_link')}
        </button>{' '}
        {t('message_suffix')}
      </span>
      <button
        type="button"
        aria-label={t('dismiss_aria_label')}
        onClick={dismiss}
        className={css({
          // Center the icon and guarantee a >=44x44 touch target (WCAG 2.5.5).
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '44px',
          minHeight: '44px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          fontSize: '20px',
          lineHeight: '1',
          color: palette.grey70,
          marginLeft: '8px',
          ':focus-visible': {
            outline: `2px solid ${palette.belizeHole}`,
            outlineOffset: '2px',
            borderRadius: '2px',
          },
        })}
      >
        <i aria-hidden="true" className="fa fa-times" />
      </button>
    </div>
  )
}

export default GrantedRewardExpirationBanner
